import { AfterViewInit, Component, OnInit } from '@angular/core';
import { DomSanitizer, Meta } from '@angular/platform-browser';
import { CommonServiceService } from '../../../shared/services/common-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DecryptionService } from '../../../shared/services/decryption.service';
@Component({
  selector: 'app-blog-details',
  standalone: true,
  imports: [],
  templateUrl: './blog-details.component.html',
  styleUrl: './blog-details.component.scss',
})
export class BlogDetailsComponent implements OnInit,AfterViewInit {
  newsId!: string | null;
  newsData: any = '';

  constructor(
    private meta: Meta,
    public sanitizer: DomSanitizer,
    private blogDataService: CommonServiceService,
    private toaster: ToastrService,
    private activatedRoute: ActivatedRoute,
    private router: Router,private decryptionApi: DecryptionService
  ) {}


  ngOnInit(): void {
    this.newsId = this.activatedRoute.snapshot.paramMap.get('id');
  }

  ngAfterViewInit(): void {
    this.blogview(this.newsId);
  }
  
  blogview(blogId: string | null) {
    this.blogDataService.newsIdData(blogId).subscribe({
      next: (res: any) => {
        const decrypt=  this.decryptionApi.decrypt(res.payload);
        const jsondecrpt=JSON.parse(decrypt);
        this.newsData = jsondecrpt;
        this.meta.addTag({
          name: 'title',
          content: jsondecrpt.title,
        });
        this.meta.updateTag({
          name: 'description',
          content: jsondecrpt.body,
        });
        this.meta.updateTag({
          name: 'subject',
          content: jsondecrpt.title,
        });
        this.meta.updateTag({
          name: 'url',
          content: this.router.url,
        });
        this.meta.updateTag({
          name: 'identifier-URL',
          content: this.router.url,
        });
        this.meta.updateTag({
          name: 'pagename',
          content: jsondecrpt.title,
        });
        this.meta.updateTag({
          name: 'og:title',
          content: jsondecrpt.title,
        });
        this.meta.updateTag({
          name: 'og:type',
          content: 'chess news',
        });
        this.meta.updateTag({
          name: 'og:url',
          content: this.router.url,
        });
        this.meta.updateTag({
          name: 'og:image',
          content: jsondecrpt.img,
        });
        this.meta.updateTag({
          name: 'og:description',
          content: jsondecrpt.body,
        });
      },
      error: (res) => {
        this.toaster.warning(res.error.message);
        this.router.navigate(['/news']);
      },
    });
  }

  copyLink(): void {
    const link = `https://chessx.ai/newsetails/${this.newsId}`;
    navigator.clipboard.writeText(link).then(() => {
      this.toaster.info('Link copied to clipboard')
    }).catch(err => {
    });
  }

  whatsappLink() {
    const whatsappLink = `https://api.whatsapp.com/send?text=https://chessx.ai/newsetails/${this.newsId}`;
    window.location.href = whatsappLink;
  }

  facebookLink() {
    const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=https://chessx.ai/newsetails/${this.newsId}`;
    window.location.href = facebookLink;
  }
  twitterLink(){
    const twitterLink = `https://twitter.com/intent/tweet?url=https://chessx.ai/newsdetails/${this.newsId}`;
    window.location.href = twitterLink;
  }

  mainMenu(){
    this.router.navigate(['news']);
  }

}
